export default __webpack_public_path__ + "static/media/1752.7a355f03.png";